import { createFileRoute } from '@tanstack/react-router';
import { SellOverview } from '../../pages/sell/SellOverview';

export const Route = createFileRoute('/dashboard/sell/')({ component: SellOverview });
